import React from "react";

import {
  EMPTY_CART_HEIGHT,
  EMPTY_CART_PATHS,
  EMPTY_CART_VIEWBOX,
  EMPTY_CART_WIDTH,
} from "./shared";

export * from "./shared";

/** WEB variant — DOM svg. The geometry comes from `./shared`. */
export const EmptyCartIllustration = () => (
  <svg
    width={EMPTY_CART_WIDTH}
    height={EMPTY_CART_HEIGHT}
    viewBox={EMPTY_CART_VIEWBOX}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {EMPTY_CART_PATHS.map((path, index) => (
      <path key={index} d={path.d} fill={path.fill} />
    ))}
  </svg>
);

export default EmptyCartIllustration;
